import { WorkspacesResponse } from 'types/api/workspaces';
import { baseApi } from './baseApi';

export const workspaceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkspaces: builder.query<WorkspacesResponse, void>({
      query: () => `/workspaces`,
    }),
  }),
});

export const { useLazyGetWorkspacesQuery, useGetWorkspacesQuery } =
  workspaceApi;
